export default __webpack_public_path__ + "static/media/p-plus.ccc0583b.png";